import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Ramo } from 'src/app/models/ramo';
import { BaseEditForm } from 'src/app/shared/baseEditForm';


@Component({
  selector: 'rami-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class RamiFormComponent extends BaseEditForm implements OnInit {

  ramo: Ramo;
  form: FormGroup;
  constructor(private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<RamiFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Ramo,) {
    super();
    this.ramo = data;
  }

  ngOnInit() {

    this.form = this.fb.group({
      nome: [this.ramo?.nome, Validators.required],
      gruppo_rami: [this.ramo?.gruppo_rami],
    });
  }

}

